var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.resourceList)?_c('div',[_c('MasterResourceList',{attrs:{"resource-list":_vm.resourceList}})],1):_vm._e(),(_vm.resourceList.length===0)?_c('div',[_c('NoResourceFoundMessage',{attrs:{"resource-name":_vm.resourceName}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }